import { Tag } from "@design-system/Tag/Tag";
import type { TagColor } from "./TagPlayground.lib";
import { Cell, handleClick, leftIcon } from "./TagPlaygroundMatrixShared";
import styles from "./TagPlayground.module.scss";

export const SmNormalRow = ({ color }: { color: TagColor }) => (
    <>
        <span className={styles.rowLabel}>{color}</span>
        <Cell>
            <Tag size="sm" color={color}>
                Tag
            </Tag>
        </Cell>
        <Cell>
            <Tag size="sm" color={color} outline>
                Tag
            </Tag>
        </Cell>
        <Cell>
            <Tag size="sm" color={color} leftIcon={leftIcon}>
                Tag
            </Tag>
        </Cell>
        <Cell>
            <Tag size="sm" color={color} outline leftIcon={leftIcon}>
                Tag
            </Tag>
        </Cell>
        <Cell>
            <Tag size="sm" color={color} numeric>
                1
            </Tag>
        </Cell>
        <Cell>
            <Tag size="sm" color={color} numeric outline>
                1
            </Tag>
        </Cell>
    </>
);

export const SmHoverRow = ({ color }: { color: TagColor }) => (
    <>
        <span className={styles.rowLabel}>{color}</span>
        <Cell>
            <Tag
                size="sm"
                color={color}
                onClick={handleClick}
                data-forced-state="hover"
            >
                Tag
            </Tag>
        </Cell>
        <Cell>
            <Tag
                size="sm"
                color={color}
                outline
                onClick={handleClick}
                data-forced-state="hover"
            >
                Tag
            </Tag>
        </Cell>
        <Cell>
            <Tag
                size="sm"
                color={color}
                leftIcon={leftIcon}
                onClick={handleClick}
                data-forced-state="hover"
            >
                Tag
            </Tag>
        </Cell>
        <Cell>
            <Tag
                size="sm"
                color={color}
                outline
                leftIcon={leftIcon}
                onClick={handleClick}
                data-forced-state="hover"
            >
                Tag
            </Tag>
        </Cell>
        <Cell>
            <Tag
                size="sm"
                color={color}
                numeric
                onClick={handleClick}
                data-forced-state="hover"
            >
                1
            </Tag>
        </Cell>
        <Cell>
            <Tag
                size="sm"
                color={color}
                numeric
                outline
                onClick={handleClick}
                data-forced-state="hover"
            >
                1
            </Tag>
        </Cell>
    </>
);

export const XsNormalRow = ({ color }: { color: TagColor }) => (
    <>
        <span className={styles.rowLabel}>{color}</span>
        <Cell>
            <Tag size="xs" color={color} numeric>
                1
            </Tag>
        </Cell>
        <Cell>
            <Tag size="xs" color={color} numeric outline>
                1
            </Tag>
        </Cell>
    </>
);

export const XsHoverRow = ({ color }: { color: TagColor }) => (
    <>
        <span className={styles.rowLabel}>{color}</span>
        <Cell>
            <Tag
                size="xs"
                color={color}
                numeric
                onClick={handleClick}
                data-forced-state="hover"
            >
                1
            </Tag>
        </Cell>
        <Cell>
            <Tag
                size="xs"
                color={color}
                numeric
                outline
                onClick={handleClick}
                data-forced-state="hover"
            >
                1
            </Tag>
        </Cell>
    </>
);
